import type { DIVISION_HEADER_FOOTER_TYPE } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaTemplatesDivisionFooter, schemaTemplatesDivisionHeader } from '../tables';

type Arguments = {
    divisionId: string;
    type: DIVISION_HEADER_FOOTER_TYPE;
};

export const schemaTemplateResolver_GetDivisionHeaderFooterTemplate = z
    .discriminatedUnion('type', [schemaTemplatesDivisionHeader, schemaTemplatesDivisionFooter])
    .nullable();

export type SchemaTemplateResolver_GetDivisionHeaderFooterTemplate = z.infer<
    typeof schemaTemplateResolver_GetDivisionHeaderFooterTemplate
>;

export type TemplateResolver_GetDivisionHeaderFooterTemplate = Resolver<
    Arguments,
    SchemaTemplateResolver_GetDivisionHeaderFooterTemplate
>;
